import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const mutationFn = ({ addressIds, stageId }) => {
  return request.put(
    'Acceptance/mass_change_stage_address_life_cycle',
    { addressIds, stageId },
    undefined,
    'Error',
    undefined,
    undefined,
    undefined,
    true
  );
};

export const useRoomListStageMutation = (options) => {
  return useMutation(mutationFn, options);
};
